const o = async (e) => {
  var c;
  const n = (c = e == null ? void 0 : e.getReader) == null ? void 0 : c.call(e);
  if (!n) return;
  const d = await n.read();
  return new TextDecoder().decode(d.value);
};
export {
  o as parseStream
};
